import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData, { FACTORS_GAME_MODE, GAME_IMAGES_KEY, SPARKLE_ANIMATION_KEY } from '../gameData';
import HitParticle from '../ninjas/HitParticles/HitParticle';
import TossItemHalf from '../ninjas/TossItemHalf';
import SoundAssetKeys from '../SoundAssetKeys';
import IntroScreenBase from './IntroScreenBase';

export default class IntroFactorsScreen extends IntroScreenBase {
  init() {
    super.init();

    this.factorSpawn1 = null;
    this.factorSpawn2 = null;
    this.lblExplaination = null;
    this.activeItems = null;
  }

  create() {
    this.displayNum = 20;

    super.create();

    gameData.gameMode = FACTORS_GAME_MODE;

    this.lblInstructions.text = 'SLICE NUMBERS TO REDUCE THEM TO\nTHEIR PRIME FACTORS.\n\nDO NOT SLICE PRIME NUMBERS.';
    this.lblInstructions.setLineSpacing(-30);
    this.lblInstructions.style.setFontSize('52pt');
    this.lblInstructions.y = 150;

    this.lblExplaination = ABCyaPhaser.Text.addText(0,0,'28pt', gameData.fontColor, FontKeys._cf_samurai_bobregular, 'A PRIME NUMBER IS A NUMBER THAT IS DIVISABLE ONLY BY ITSELF AND 1', this, true).setOrigin(0.5);
    this.lblExplaination.x = this.scale.width / 2;
    this.lblExplaination.y = this.scale.height - 70;

    this.swipe.y = 340;
    this.objectDisplay.y = this.swipe.y + this.swipe.height / 2 + 26;
    this.pointerHand.y = this.swipe.y;
  }

  doSlice () {
    ABCyaPhaser.Tweens.addTween(this.pointerHand, 600, { x: this.swipe.x + this.swipe.width, y: this.swipe.y + this.swipe.height, alpha: 1 }, Phaser.Math.Easing.Linear);
    this.swipe.play('start');
    this.swipe.setVisible(true);

    this.time.delayedCall(200, this.sliceIntroObject, null, this);
    ABCyaPhaser.Tweens.addTween(this.swipe, 200, { delay: 400, alpha: 0 });
  }

  sliceIntroObject() {
    super.sliceIntroObject();

    // Make the factor spawns
    let value = 10;
    let sn = `Num${value}`;
    this.factorSpawn1 = ABCyaPhaser.Images.addImage(this.objectDisplay.x, this.objectDisplay.y, sn, this, GAME_IMAGES_KEY);
    ABCyaPhaser.Tweens.addTween(this.factorSpawn1, 1200, { x: this.factorSpawn1.x + 183, y: this.factorSpawn1.y - 120 }, Phaser.Math.Easing.Linear, () => this.sliceFactorNumber());

    value = 2;
    sn = `Num${value}`;
    this.factorSpawn2 = ABCyaPhaser.Images.addImage(this.objectDisplay.x, this.objectDisplay.y, sn, this, GAME_IMAGES_KEY);

    ABCyaPhaser.Tweens.addTween(this.factorSpawn2, 1200, { x: this.factorSpawn2.x - 168, y: this.factorSpawn2.y - 260 }, Phaser.Math.Easing.Linear);

    this.time.delayedCall(1000, this.doSlice2, null, this);
  }

  sliceFactorNumber () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._correct_slice, this);
    const num = '10';
    const pt = ABCyaPhaser.GameObjects.getScreenPosition(this.factorSpawn1);
    let item = new TossItemHalf(this);
    item.angle = this.objectDisplay.angle;
    item.reset(`Num${num}`, 1, pt.x,pt.y);
    this.halves.push(item);
    this.add.existing(item);

    item = new TossItemHalf(this);
    item.reset(`Num${num}`, 2, pt.x,pt.y);
    item.angle = this.objectDisplay.angle;
    this.halves.push(item);
    this.add.existing(item);

    const count = 50;
    for (let i = 0; i < count; i++) {
      item = new HitParticle(this);
      item.reset(pt.x,pt.y,Phaser.Math.Between(0,this.textures.get(SPARKLE_ANIMATION_KEY).frameTotal - 2));
      this.add.existing(item);
      this.hitParticles.push(item);
    }

    this.factorSpawn1.destroy();
    ABCyaPhaser.Tweens.addTween(this.factorSpawn2, 650, { alpha: 0 }, Phaser.Math.Easing.Linear, () => this.goAway());
  }

  doSlice2 () {
    this.swipe.x = 190;
    this.swipe.y = 212;

    this.swipe.alpha = 1;
    this.pointerHand.x = this.swipe.x;
    this.pointerHand.y = this.swipe.y;
    ABCyaPhaser.Tweens.addTween(this.pointerHand, 600, { x: this.swipe.x + this.swipe.width, y: this.swipe.y + this.swipe.height }, Phaser.Math.Easing.Linear);
    this.swipe.play('start');
    ABCyaPhaser.Tweens.addTween(this.swipe, 220, { delay: 300, alpha: 0 }, Phaser.Math.Easing.Linear);
  }

  goAway () {
    ABCyaPhaser.Tweens.addTween([this.lblInstructions, this.pointerHand, this.swipe, this.lblExplaination], 600, { delay: 500, alpha: 0 }, Phaser.Math.Easing.Linear, () => this.allDone());
  }
}